import { render, staticRenderFns } from "./rejectOrAgreeDialog.vue?vue&type=template&id=24b724da&scoped=true"
import script from "./rejectOrAgreeDialog.vue?vue&type=script&lang=js"
export * from "./rejectOrAgreeDialog.vue?vue&type=script&lang=js"
import style0 from "./rejectOrAgreeDialog.vue?vue&type=style&index=0&id=24b724da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b724da",
  null
  
)

export default component.exports